import React, { useContext } from 'react';
import Loading from './Loading';
import MyParticipateWaysContext from '../context/ParticipateWaysContext';

const ParticipateItem = ({participateWay, number}) => {
    const { files, getFile, loading } = useContext(MyParticipateWaysContext);


    const wayDate = new Date(participateWay.participateWayCreationDate);
    const options = {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric",
    };
    const newDateFormated = wayDate.toLocaleDateString("es-ES", options);

    const showYoutubeVideo = () => {
        return(
            <iframe className='w-full my-5 2sm:w-[90%] lg:w-[45%] 2md:w-[80%] h-[250px] md:h-[300px]' src={participateWay.participateWayVideoPath} title="Catastro" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        )
    }

    const showImage = () => {
        return(
            <div className={`flex lg:h-[calc(40vh)] 2lg:h-[calc(50vh)] sm:w-[90%] 2sm:w-[80%] md:w-[70%] 2md:w-[60%] lg:w-[45%] 2lg:w-[40%] drop-shadow-lg`} >
                <img
                src={`data:image/png;base64,${files[number]}`}
                alt={"newN.newTitle"}
                className="rounded-xl"
                />
            </div>
        )
    }
    return (
        <div className="mx-[4%] px-[3%] 2sm:px-[2%] py-5 md:py-0 mt-8 flex flex-col items-center rounded-2xl mb-10">
            <div className={`flex flex-col lg:flex-row items-center justify-between ${(participateWay.participateWayImagePath || participateWay.participateWayVideoPath) && 'lg:h-[calc(40vh)] 2lg:h-[calc(50vh)]'} bg-blues-300 w-full gap-2`}>
                <div className={`${(participateWay.participateWayImagePath || participateWay.participateWayVideoPath) ? 'lg:w-[45%] text-left' : 'w-full text-center'} w-full h-full font-garamond leading-tight flex flex-col 2md:justify-end`}>
                    <h2 className={`text-4xl xl:text-5xl font-bold w-full`} >
                        {participateWay.participateWayTitle}
                    </h2>
                    <h2 className={`pt-2 flex flex-row text-gray-600 text-sm 2sm:text-base`} >
                        {newDateFormated}
                    </h2>
                </div>
                {(participateWay.participateWayImagePath || participateWay.participateWayVideoPath) && <div className={`lg:w-[1px] lg:h-[70%] 2md:bg-pageHeader rounded-sm shadow-sm invisible lg:visible`} />}
                {participateWay.participateWayImagePath ? showImage() : participateWay.participateWayVideoPath && showYoutubeVideo()}
            </div>
            <div className={` flex flex-wrap w-[85%] rounded-sm border-t-2 border-pageHeader my-4 md:mb-4 justify-around font-podkova p-2 items-center`} >
                {participateWay.participateWayFilePath ? loading ? <Loading isLoading={true} /> : <button className="flex flex-row justify-around w-[45%] md:w-[30%] lg:w-[20%] items-center border-b-2 border-pageHeader hover:bg-pageHeader hover:text-white transition-all duration-500 hover:rounded-2xl p-2" onClick={() => getFile(participateWay.participateWayFilePath)}>Ver Documento</button> : null}
            </div>
            <p>
                {participateWay.participateWayDescription.split('\r\n').map((item, i) => {
                    return <span key={i}>{item}<br /></span>
                })}
            </p>
            {(participateWay.participateWayImagePath && participateWay.participateWayVideoPath) && showYoutubeVideo()}
        </div>
    );
}
 
export default ParticipateItem;